import { message } from 'antd';
import { all, call, fork, put, takeEvery, takeLatest } from "redux-saga/effects";
import { GET_VISITS_REPORT, GET_VISITS_REPORT_ERROR, GET_VISITS_REPORT_SUCCESS, GET_VISITS_REPORT_START, GET_VISITS_REPORT_RELOAD } from "../../../constants/ActionTypes";
import { getVisitsReportAPI } from "../../../services/visits-report-service";


function* fetchVisitsReportAPI({ payload }) {

    try {
        yield put({ type: GET_VISITS_REPORT_START })
        const response = yield call(getVisitsReportAPI, payload.filteredData);

        if (response.success) {
            yield put({ type: GET_VISITS_REPORT_SUCCESS, visitsReport: response.visitReports.length > 0 ? [...response.visitReports] : [] })
        } else {
            yield put({ type: GET_VISITS_REPORT_ERROR, error: response.error })
            message.error('Failed to fetch visits report!');
        }
    } catch (error) {
        message.error('Failed to fetch visits report!');
        yield put({ type: GET_VISITS_REPORT_ERROR, 'error': error })
    }
}

function* fetchVisitsReportReloadAPI({ payload }) {

    try {
        yield put({ type: GET_VISITS_REPORT_START })
        const response = yield call(getVisitsReportAPI, payload.filteredData);

        if (response.success) {
            payload.resolve({ success: true })

            yield put({ type: GET_VISITS_REPORT_SUCCESS, visitsReport: response.visitReports.length > 0 ? [...response.visitReports] : [] })
        } else {
            payload.resolve({ success: false })

            yield put({ type: GET_VISITS_REPORT_ERROR, error: response.error })
            message.error('Failed to fetch visits report!');
        }
    } catch (error) {
        payload.resolve({ success: false })
        message.error('Failed to fetch visits report!');
        yield put({ type: GET_VISITS_REPORT_ERROR, 'error': error })
    }
}

function* getVisitsReportWatcher() {
    yield takeLatest(GET_VISITS_REPORT, fetchVisitsReportAPI);
}
function* getVisitsReportReloadWatcher() {
    yield takeLatest(GET_VISITS_REPORT_RELOAD, fetchVisitsReportReloadAPI)
}

export default function* rootSaga() {
    yield all([getVisitsReportWatcher(),
    getVisitsReportReloadWatcher()])
}

